export default class CloseMergeProfileModal {
  constructor(context) {
    this.context = context;
  }

  run() {
    this.context.stores.customerMerge.clearErrors();
    this.context.stores.modal.remove();
  }
}



// WEBPACK FOOTER //
// ./src/scripts/application/actions/customer/close_merge_profile_modal.js